export const linkPaymentData = {
  documentType: 'PSP',
  userName: 'noname',
  document: '11111',
  phone: '11111111',
  email: 'mail@mail.com',
};
